import * as React from 'react'
import type { CommonDeps } from '../../base/CommonDeps'
import type { PhotoUrls } from '../../../../shared/domain/reports/types.no-deps'
import type { PhotoFile } from '../../../../shared/domain/flows'
import { InspectableImage } from '../../photo/InspectableImage'
import { withS3ImageUrl } from '../../file/withS3Url'
import type { Nullable } from '../../../../shared/lib/typeHelpers.no-deps'

interface Props {
    deps: CommonDeps
    photoFile: PhotoFile
    photoUrls: PhotoUrls
    allowZoom?: boolean
}

export class PhotoAnswer extends React.Component<Props> {
    public renderAnnotatedPhoto = (src: string, fullSizeSrc: string) => {
        return withS3ImageUrl(
            this.props.deps,
            this.props.photoUrls[this.props.photoFile.annotation],
            ({ fullSizeS3Url }) => this.renderImage(src, fullSizeSrc, fullSizeS3Url)
        )
    }

    public renderSimplePhoto = (src: string, fullSizeSrc: string) => {
        return this.renderImage(src, fullSizeSrc, null)
    }

    public renderImage = (src: string, fullSizeSrc: string, annotation: Nullable<string>) => {
        if (!this.props.allowZoom) {
            return (
                <zaptic-annotated-image
                    key={fullSizeSrc}
                    className="AppCore__report__ViewAnswer__Image"
                    src={fullSizeSrc}
                    annotation={annotation}
                />
            )
        }

        return (
            <InspectableImage
                src={src}
                annotation={annotation}
                title=""
                fullSizeSrc={fullSizeSrc}
                deps={this.props.deps}
                imageClass="AppCore__report__ViewAnswer__Image"
            />
        )
    }

    public render = () => {
        return withS3ImageUrl(
            this.props.deps,
            this.props.photoUrls[this.props.photoFile.photo],
            ({ fullSizeS3Url, thumbnailS3Url }) =>
                this.props.photoFile.annotation
                    ? this.renderAnnotatedPhoto(thumbnailS3Url, fullSizeS3Url)
                    : this.renderSimplePhoto(thumbnailS3Url, fullSizeS3Url)
        )
    }
}
